/** Elapsed seconds before ops banner stops extrapolating ETA. */
export const OPS_BANNER_STUCK_ELAPSED_SEC = 120;

/** Maximum ETA seconds shown — no absurd extrapolation. */
export const OPS_BANNER_MAX_ETA_SEC = 600;

/** Progress below this after OPS_BANNER_STUCK_ELAPSED_SEC → stuck message. */
export const OPS_BANNER_STUCK_PROGRESS = 0.05;

export type OpsBannerProgressInput = {
  headerElapsedSec: number;
  clampedHeaderProgress?: number;
};

export function isOpsBannerProgressStuck(input: OpsBannerProgressInput): boolean {
  const { headerElapsedSec, clampedHeaderProgress: progress } = input;
  if (headerElapsedSec < OPS_BANNER_STUCK_ELAPSED_SEC) return false;
  if (progress == null || progress <= 0) return true;
  if (progress < OPS_BANNER_STUCK_PROGRESS) return true;
  if (progress < 1 && headerElapsedSec / progress > OPS_BANNER_MAX_ETA_SEC) return true;
  return false;
}

export function computeOpsBannerEtaSec(input: OpsBannerProgressInput): number | null {
  const { headerElapsedSec, clampedHeaderProgress: progress } = input;
  if (progress == null || progress <= 0 || progress >= 1) return null;
  if (isOpsBannerProgressStuck(input)) return null;
  const raw = Math.max(0, Math.round((headerElapsedSec / progress) - headerElapsedSec));
  return Math.min(raw, OPS_BANNER_MAX_ETA_SEC);
}
